import React from 'react';
import { SelectGroup, SelectLabel, SelectItem } from './ui/select';

// Sort helper: alphabetical (A→Z) by project_name, case-insensitive.
export const sortProjectsAlpha = (arr) =>
  [...(arr || [])].sort((a, b) =>
    (a?.project_name || '').localeCompare(b?.project_name || '', undefined, { sensitivity: 'base' })
  );

const firstLetter = (name) => ((name || '').trim().charAt(0) || '#').toUpperCase();

// Renders project options grouped under a single-letter header (phonebook style):
// each letter appears once, with all projects starting with that letter listed beneath it.
export const GroupedProjectItems = ({ projects, valueKey = 'project_id', getLabel }) => {
  const sorted = sortProjectsAlpha(projects);
  const groups = {};
  sorted.forEach((p) => {
    const letter = firstLetter(p.project_name);
    (groups[letter] = groups[letter] || []).push(p);
  });
  return Object.keys(groups)
    .sort((a, b) => a.localeCompare(b))
    .map((letter) => (
      <SelectGroup key={letter}>
        <SelectLabel className="text-[11px] font-bold text-primary bg-muted/60 sticky top-0">{letter}</SelectLabel>
        {groups[letter].map((p) => (
          <SelectItem key={p[valueKey]} value={p[valueKey]}>
            {getLabel ? getLabel(p) : p.project_name}
          </SelectItem>
        ))}
      </SelectGroup>
    ));
};

export default GroupedProjectItems;
